import React, { Component } from "react";

import { Tag } from "@blueprintjs/core";

import { Grid, Row, Col } from "react-flexbox-grid";

import "./index.css";

class Details extends Component {
  render() {
    return (
      <DetailsInformation
        details={this.props.details}
        formated_date={this.props.date}
        formated_time={this.props.time}
        instructors={this.props.instructors}

      />
    );
  }
}

const DetailsInformation = (props) => (
  <div>
    <Grid className="div-details">
      <Row>
        <fieldset className="field-style">
          <legend> General Information </legend>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event Name(Arabic): </strong>
            </Col>
            <Col xs={4}> {props.details.event_name_ar} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event Program: </strong>
            </Col>
            <Col xs={4}> {props.details.program} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event Category: </strong>
            </Col>
            <Col xs={4}> {props.details.category} </Col>
          </Row>

          <Row middle="xs">
            <Col xs={4}>
              <strong> Event Instructors: </strong>
            </Col>
            <Col xs={4}>
              {props.instructors.map((item, index) => (
                <span key={index}>
                  <Tag> {item} </Tag>
                </span>
              ))}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Instructor is guest: </strong>
            </Col>
            <Col xs={4}> {props.details.isGuest ? "Yes" : "No"} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Venue: </strong>
            </Col>
            <Col xs={4}> {props.details.venue} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> City: </strong>
            </Col>
            <Col xs={4}> {props.details.city} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Center Type: </strong>
            </Col>
            <Col xs={4}>
              {props.details.hasOwnProperty("center_type")
                ? props.details.center_type
                : "ai-ds"}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event Type: </strong>
            </Col>
            <Col xs={4}>
              <Tag>
                {props.details.event_type.hasOwnProperty("value")
                  ? props.details.event_type.value
                  : props.details.event_type}
              </Tag>
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Confirmation Type: </strong>
            </Col>
            <Col xs={4}>
              <Tag> {props.details.confirmation_type} </Tag>
            </Col>
          </Row>

          <Row middle="xs">
            <Col xs={4}>
              <strong> Livestream: </strong>
            </Col>
            <Col xs={4}> {props.details.livestream ? "Yes" : "No"} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event is canceled: </strong>
            </Col>
            <Col xs={4}> {props.details.isCanceled ? "Yes" : "No"} </Col>
          </Row>
        </fieldset>
      </Row>
      <Row>
        <fieldset className="field-style">
          <legend> Date & Time </legend>
          <Row middle="xs">
            <Col xs={1}>
              <strong> Date: </strong>
            </Col>
            <Col xs={4}>
              {props.formated_date.map((item, index) => (
                <p key={index}> {item} </p>
              ))}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={1}>
              <strong> Time: </strong>
            </Col>
            <Col xs={4}>
              {props.formated_time.map((item, index) => (
                <p key={index}> {item} </p>
              ))}
            </Col>
          </Row>
        </fieldset>
      </Row>

      <Row>
        <fieldset className="field-style">
          <legend> Statistics </legend>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event capacity: </strong>
            </Col>
            <Col xs={4}> {props.details.max_attendees} </Col>
          </Row>
         
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of live streams: </strong>
            </Col>
            <Col xs={4}>
              {props.details.hasOwnProperty("nlive_streams")
                ? props.details.nlive_streams
                : 0}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of Waitlist: </strong>
            </Col>
            <Col xs={4}>
              {props.details.waitlist ? props.details.nWaiting : "N/A"}
            </Col>
          </Row>
        </fieldset>
      </Row>

      <Row>
        <fieldset className="field-style">
          <legend> Webflow & Email Settings </legend>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Difficulty: </strong>
            </Col>
            <Col xs={4}> {props.details.difficulty} </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Target audience: </strong>
            </Col>
            <Col xs={4}>
              {props.details.target_audience === undefined
                ? ""
                : formatAudiance(props.details.target_audience)}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> For whom: </strong>
            </Col>
            <Col xs={8}>
              {props.details.for_whom === "" ? "N/A" : props.details.for_whom}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Short description: </strong>
            </Col>
            <Col xs={8}>
              {props.details.short_desc === ""
                ? "N/A"
                : props.details.short_desc}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event description: </strong>
            </Col>
            <Col xs={8}>
              {props.details.desc_webflow === undefined
                ? "N/A"
                : formatText(props.details.desc_webflow)}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event See More description: </strong>
            </Col>
            <Col xs={8}>
              {props.details.see_more === undefined
                ? "N/A"
                : formatText(props.details.see_more)}
            </Col>
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event notes: </strong>
            </Col>
            <Col xs={8}>
              {props.details.desc_webflow === undefined
                ? "N/A"
                : formatText(props.details.notes)}
            </Col>
          </Row>
        </fieldset>
      </Row>
    </Grid>
  </div>
);

const formatAudiance = (audiance) => {
  let targetAudianceOptions = [
    {
      label: "General Events (فعاليات عامة)",
      value: "General Events",
    },
    {
      label: "Entrepreneurs (رواد أعمال)",
      value: "Entrepreneurs",
    },
    {
      label: "SMEs (أصحاب منشآت صغيرة ومتوسطة)",
      value: "SMEs",
    },
    //old collections:
    {
      label: "General Events (فعاليات عامة)",
      value: "5db050076249007c80b7a90b",
    },
    { label: "Entrepreneurs (رواد أعمال)", value: "5db05007624900761fb7a8f9" },
    {
      label: "SMEs (أصحاب منشآت صغيرة ومتوسطة) ",
      value: "5db05007624900fffbb7a91e",
    },

    {
      label: "General Events (فعاليات عامة) - old",
      value: "5d3595e0166bd86b3aae77fc",
    },
    {
      label: "Entrepreneurs (رواد أعمال) - old ",
      value: "5d3595e0166bd8459aae77e8",
    },
    {
      label: "SMEs (أصحاب منشآت صغيرة ومتوسطة) - old ",
      value: "5d3595e0166bd81a62ae7810",
    },
    { label: " ", value: "" },
  ];
  return targetAudianceOptions.filter((option) => option.value === audiance)[0]
    .label;
};

const formatText = (data) => {
  var text = data.toString();
  return text.replace(/<\/?[^>]+>/gi, " ").trim();
};

export default Details;


/*

<Row>
      
        <fieldset className="field-style">
          <legend> Statistics </legend> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Event capacity: </strong> 
            </Col> 
            <Col xs={4}> {props.details.max_attendees} </Col> 
          </Row> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Expected Number of Attendees: </strong> 
            </Col> 
            <Col xs={4}> {props.details.expected_attendees} </Col> 
          </Row> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of Registered Users: </strong> 
            </Col> 
            <Col xs={4}> {props.details.nRegistered} </Col> 
          </Row> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of Attendees: </strong> 
            </Col> 
            <Col xs={4}> {props.details.nAttended} </Col> 
          </Row> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of Cancelation: </strong> 
            </Col> 
            <Col xs={4}>
               
              {countCancelation(props.userList, props.details)} 
            </Col> 
          </Row> 
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of live streams: </strong> 
            </Col> 
            <Col xs={4}>
               
              {props.details.hasOwnProperty("nlive_streams")
                ? props.details.nlive_streams
                : 0} 
            </Col> 
          </Row>
          <Row middle="xs">
            <Col xs={4}>
              <strong> Number of Waitlist: </strong> 
            </Col> 
            <Col xs={4}>
               
              {props.details.waitlist ? props.details.nWaiting : "N/A"} 
            </Col> 
          </Row> 
        </fieldset> 
      </Row> 


const countCancelation = (users, details) => {
  //something's wrong...
  let nRegistered = users.length;
  let nConfirmed = details.hasOwnProperty("registrationids") ? users.length : 0;

  let nCanceled = nRegistered - nConfirmed;

  return nCanceled;
};


*/